import React from "react";
import { ReactSVG } from "react-svg";

import './SVGIcon.scss'
import IconInterface from "./IconInterface";

const icons = import.meta.glob<string>('./svg/*.svg', { eager: true, import: 'default' })

export default class SVGIcon implements IconInterface
{
    name: string

    constructor(name: string) {
        this.name = name
    }

    get(): React.ReactNode {
        const svg = icons[`./svg/${this.name}.svg`]

        return (
            <ReactSVG src={svg} className="svg-icon"/>
        )
    }
}
